module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "segment-main"
  }, [_c('h1', {
    staticClass: "title has-text-centered"
  }, [_vm._v("Gamesheet Cards ")]), _vm._v(" "), (this.Gamesheet.length <= 0) ? _c('span', [_c('h2', {
    staticClass: "segment title has-text-centered"
  }, [_vm._v("No data or Loading...")])]) : _vm._e(), _vm._v(" "), _vm._l((this.Gamesheet), function(player) {
    return _c('div', {
      key: player.number,
      staticClass: "segment"
    }, [(player.number !== null) ? _c('div', [_c('h2', {
      staticClass: "subtitle has-text-centered devils"
    }, [_vm._v(_vm._s(player.number))]), _vm._v(" "), _c('div', {
      staticClass: "columns"
    }, [_c('div', {
      staticClass: "column"
    }, [_c('h2', {
      staticClass: "subheading has-text-centered"
    }, [_vm._v("Goals")]), _vm._v(" "), _c('p', {
      staticClass: "stat-number has-text-centered"
    }, [_vm._v("+ " + _vm._s(player.goals_for))]), _vm._v(" "), _c('p', {
      staticClass: "stat-number has-text-centered"
    }, [_vm._v("- " + _vm._s(player.goals_for))]), _vm._v(" "), _c('p', {
      staticClass: "stat-number has-text-centered"
    }, [_vm._v("+/- " + _vm._s(player.goal_diff))])]), _vm._v(" "), _c('div', {
      staticClass: "column"
    }, [_c('h2', {
      staticClass: "subheading has-text-centered"
    }, [_vm._v("Faceoffs")]), _vm._v(" "), _c('p', {
      staticClass: "stat-number has-text-centered"
    }, [_vm._v(" Won / Taken " + _vm._s(player.fo))])]), _vm._v(" "), _c('div', {
      staticClass: "column"
    }, [_c('h2', {
      staticClass: "subheading has-text-centered"
    }, [_vm._v("Shots")]), _vm._v(" "), _c('p', {
      staticClass: "stat-number has-text-centered"
    }, [_vm._v("+ " + _vm._s(player.shots_for))]), _vm._v(" "), _c('p', {
      staticClass: "stat-number has-text-centered"
    }, [_vm._v("- " + _vm._s(player.shots_against))]), _vm._v(" "), _c('p', {
      staticClass: "stat-number has-text-centered"
    }, [_vm._v("+/- " + _vm._s(player.shots_plus_minus))]), _vm._v(" "), _c('p', {
      staticClass: "stat-number has-text-centered"
    }, [_vm._v("On Net " + _vm._s(player.sot))])]), _vm._v(" "), _c('div', {
      staticClass: "column"
    }, [_c('h2', {
      staticClass: "subheading has-text-centered"
    }, [_vm._v("Ice Time")]), _vm._v(" "), _c('p', {
      staticClass: "stat-number has-text-centered"
    }, [_vm._v("Total TOI" + _vm._s(player.total_toi))]), _vm._v(" "), _c('p', {
      staticClass: "stat-number has-text-centered"
    }, [_vm._v("Shifts " + _vm._s(player.shifts))]), _vm._v(" "), _c('p', {
      staticClass: "stat-number has-text-centered"
    }, [_vm._v("Average " + _vm._s(player.avg_shift))]), _vm._v(" "), _c('p', {
      staticClass: "stat-number has-text-centered"
    }, [_vm._v("Even Handed " + _vm._s(player.eh_time))]), _vm._v(" "), _c('p', {
      staticClass: "stat-number has-text-centered"
    }, [_vm._v("Power Play " + _vm._s(player.pp_time))]), _vm._v(" "), _c('p', {
      staticClass: "stat-number has-text-centered"
    }, [_vm._v("Short Handed " + _vm._s(player.sh_time))])])])]) : _vm._e()])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e02b1c0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/stats/season-stats/Gamesheet2021.vue
// module id = 632
// module chunks = 30